<template>
  <div class="z-10 fixed! bottom-0 px-3 w-full">
    <div
      class="w-full grid grid-cols-5 justify-around liquidGlassCard relative rounded-full px-4 pt-4 pb-2 shadow-2xl!"
    >
      <router-link
        v-for="(tab, i) in [
          {
            name: 'Accueil',
            icon: 'search-file.svg',
            id: 'home',
            default: true
          },
          {
            name: 'Achats',
            icon: 'order-history.svg',
            id: 'orders',
            default: false
          },
          {
            name: 'Bonus',
            icon: 'rewards.svg',
            id: 'rewards',
            default: false
          },
          {
            name: 'Promo',
            icon: 'hot-sale.svg',
            id: 'deals',
            default: false
          },
          {
            name: 'Colis',
            icon: 'delivery-man.svg',
            id: 'packages',
            default: false
          }
        ]"
        :key="i"
        :to="`/${tab.id}`"
        class="flex flex-col items-center gap-3 rounded-2xl duration-300"
        :class="{
          'text-primary-700': $route.name == tab.id,
          'text-[#010101]': $route.name !== tab.id
        }"
      >
        <ColorImg
          :src="`/images/bottomNavs/${tab.icon}`"
          class="w-7 h-7 bg-current"
        />
        <div class="w-max text-center text-xs">
          {{ tab.name }}
        </div>
      </router-link>
    </div>
    <div class="py-4 mobile-bottom-padding"></div>
  </div>
</template>
